import { DataColumn } from "../../models/ColumnDefintion";

export class AddVacColumnDefinition {
  static readonly type = "[VacColDef] Add";
  constructor(public payload: DataColumn[]) {}
}

export class RemoveVacColumnDefinition {
  static readonly type = "[VacColDef] Remove";
  constructor() {}
}
